import React, { useEffect, useState, useRef } from "react";


import FormModal from "../../widgets/FormModal";

function YourHealth() {
  const [index, setIndex] = useState(0);
  const leftMenuRef = useRef(null);
  const [show, setShow] = useState(false);
  const openIframeWindow = () => {
    setShow(!show);
  }

  // Collect menu items and right-box content together
  const menuItems = [
    {
      id: "nutrition",
      label: "Genetic Risks",
      img: "/assets/img/risk.png",
      text: `Type 2 Diabetes Risk, Alzheimer’s & Lipid Metabolism,
             Obesity Susceptibility, Cancer Risk Hypertension Risk,
             Breast & Ovarian Cancer Predisposition`,
    },
    {
      id: "metabolic",
      label: "Metabolic Markers",
      img: "/assets/img/markers.png",
      text: `Insulin sensitivity, fat metabolism, Adiponectin levels,
             Glucose transport, Lipid absorption & cholesterol levels,
             Fatty acid binding and absorption`,
    },
    {
      id: "fitness",
      label: "Nutrition & Detox",
      img: "/assets/img/detox.png",
      text: `Folate, B12 Metabolism, Caffeine Metabolism,
             Antioxidant & Detoxification Enzymes,
             Vitamin B12 Absorption, Oxidative Stress Defense`,
    },
    {
      id: "fitness1",
      label: "Fitness Response",
      img: "/assets/img/response.png",
      text: `Power Vs Endurance Potential, Aerobic Capacity, Endurance,
             Mitochondrial Biogenesis, Vo₂ Max, Tendon & Ligament
             Injury Risk, Blood Flow And Endurance Adaptation`,
    },
    {
      id: "fitness2",
      label: "Sleep & Recovery",
      img: "/assets/img/sleep.png",
      text: `Circadian Rhythm Regulation, Sleep-Wake Cycles,
             Sleep Duration & Caffeine Sensitivity, Dopamine Breakdown,
             Stress Recovery, Neural Recovery & Plasticity During Sleep`,
    },
    {
      id: "fitness3",
      label: "Cognitive Function",
      img: "/assets/img/function.png",
      text: `Alzheimer’s Risk, Memory Decline Learning, Memory,
             Stress Resilience, Cognitive Flexibility, Executive Function,
             Dopamine Signaling, Motivation, Attention, Processing Speed`,
    },
  ];

  // Auto slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % menuItems.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [menuItems.length]);

  // Left menu auto scroll effect
  useEffect(() => {
    const activeItem = document.getElementById(`menu-${index}`);
    if (activeItem && leftMenuRef.current) {
      leftMenuRef.current.style.transform = `translateY(-${activeItem.offsetTop}px)`;
      leftMenuRef.current.style.transition = "transform 0.8s ease";
    }
  }, [index]);

  return (
    <section className="your_health_slider ps overflow-hidden position-relative">
      <div className="container">
        <div className="row align-items-center">
          {/* Center Circle */}
          <div className="col-lg-4 order-lg-2">
            <div className="center-content">
              <div className="circle">
                <div>
                  <h2 className="hadding">
                    Your Health,
                    <br />
                    Decoded
                  </h2>
                  <p>
                    With insights into 275+ health triggers, EPLIMO gives you
                    the clarity to manage risks before they become problems.
                  </p>
                  <button className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</button>
                </div>
              </div>
            </div>
          </div>

          {/* Left Menu */}
          <div className="col-lg-4 h_300px order-lg-1 position-relative">
            <div className="left_box_slider">
              <div
                className="left-menu"
                id="leftMenu"
                ref={leftMenuRef}
                onWheel={(e) => e.preventDefault()}
                onTouchMove={(e) => e.preventDefault()}
              >
                {menuItems.map((item, i) => (
                  <div
                    key={item.id}
                    id={`menu-${i}`}
                    className={`menu-item ${i === index ? "active" : ""}`}
                    onClick={() => setIndex(i)}
                  >
                    <img src={item.img} alt={item.label} />
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Boxes */}
          <div className="col-lg-4 order-lg-3 h_300px">
            {menuItems.map((item, i) => (
              <div
                key={item.id}
                id={item.id}
                className={`right-box ${i === index ? "active" : "d-none"}`}
              >
                <div className="d-flex gap-3 align-items-center">
                  <img src={item.img} alt={item.label} />
                  {item.label}
                </div>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
        <FormModal show={show} setShow={setShow} />
      </div>
    </section>
  );
}

export default YourHealth;
